<template>
    <div class="cart">
        <a :href="'/' + culture + '/shop/review'" onclick="return false;" rel="nofollow" v-on:click="toggleCartSlider(true, Cart.NumberOfCartItems)" class="cart-summary-container2 fadeIn track-GA4-event" data-ga4_name="navigation_click" data-ga4_title="n/a" data-ga4_title1="n/a" data-ga4_click_text="cart" id="cart-summary-container2" :class="Cart.NumberOfCartItems == undefined || Cart.NumberOfCartItems == 0 ? 'cart-summary-empty' : ''">
            <span v-if="!enableDiscoverMode" aria-hidden="true"><i class="glyphicon glyphicon-shopping-cart"></i></span>
            <span v-else aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M4.23622 5.68945H2.10352V3.68945H5.97081L7.47081 14.1895H16.8352L18.3019 8.68945H8.10352L11.6035 6.68945H20.9051L18.3718 16.1895H5.73622L4.23622 5.68945Z" />
                    <path fill="currentColor" d="M9.60352 19.1895C9.60352 20.0179 8.93194 20.6895 8.10352 20.6895C7.27509 20.6895 6.60352 20.0179 6.60352 19.1895C6.60352 18.361 7.27509 17.6895 8.10352 17.6895C8.93194 17.6895 9.60352 18.361 9.60352 19.1895Z" />
                    <path fill="currentColor" d="M17.6035 19.1895C17.6035 20.0179 16.9319 20.6895 16.1035 20.6895C15.2751 20.6895 14.6035 20.0179 14.6035 19.1895C14.6035 18.361 15.2751 17.6895 16.1035 17.6895C16.9319 17.6895 17.6035 18.361 17.6035 19.1895Z" />
                </svg>
            </span>
            <span class="sr-only">{{ Cart.NumberOfCartItems }} item(s) in cart</span>
            <span id="summary-NumberOfItems" class="NumberOfItems" v-show="Cart.NumberOfCartItems != undefined && Cart.NumberOfCartItems > 0">{{ Cart.NumberOfCartItems }}</span>
            <span class="NumberOfItems ZeroItems" v-show="Cart.NumberOfCartItems == undefined || Cart.NumberOfCartItems == 0">0</span>
            <span id="summary-total" class="hidden-xs">{{ Cart.TotalToFormat }}</span>
            <span class="sr-only">{{getInterfaceText('cart_total_amount')}} {{ Cart.TotalToFormat }}</span>
        </a>

        <!-- cart slider -->
        <div id="cart-summary-slider" :style="displaySlider" :class="isCartSummaryOpen && ((Cart.CartItems && Cart.CartItems.length > 0) || ignoreItemCount) ? 'slide-out' : 'slide-in'" aria-label="Cart" role="dialog" aria-modal="true" v-if="isOpen" @keydown="handleKeydown" ref="modal">
            <div id="overlay" style="width: 100%; height: 100%; position: inherit; top: 0; left: 0; background: rgba(0, 0, 0, 0.3); z-index: 99;" v-show="CartInProgress == true">
                <div class="lds-dual-ring" style="min-height:100%"></div>
            </div>
            <div id="title-and-close-button" class="clearfix">
                <div class="title">
                    <h2>{{getInterfaceText('shoppingcart')}}</h2>
                </div>
                <div class="close-button text-right">
                    <button v-on:click="toggleCartSlider(false)" id="cartCloseButton" aria-label="close" class="btn-close">&times;</button>
                </div>
            </div>

            <div id="body" v-show="CartHasItems">
                <div v-show="Cart.LockedCart == false">
                    <CartTable :edit-mode="true" :summary-mode="true"></CartTable>
                </div>
                <div v-show="Cart.LockedCart == true" v-html="Cart.LockedCartDescription"></div>
            </div>

            <div id="body" class="emptycart" v-show="!CartHasItems">
                <h3>{{getInterfaceText('shoppingcart_yourcartisempty')}}</h3>
                <p style="margin-bottom: 24px;">
                    {{getInterfaceText('shoppingcart_whenyouaddproducts')}}
                </p>
               
                <div class="discovermode-button-component-wrapper">
                    <a href="/" class="button-component outlined">
                        <div class="motion-track-slides">
                            <span class="motion-track-slide-main">{{getInterfaceText('shop_continueshopping')}}</span>
                            <span class="motion-track-slide-pseudo" aria-hidden="true">{{getInterfaceText('shop_continueshopping')}}</span>
                        </div>
                    </a>
                </div>
                
            </div>

            <div id="relatedproducts" v-if="Cart.RelatedProducts && Cart.RelatedProducts.length > 0">
                <RelatedProducts></RelatedProducts>
            </div>

            <div id="totals" v-show="CartHasItems">
                <CartTotals :edit-mode="true" :summary-mode="true"></CartTotals>
            </div>

            <div id="actions" v-show="CartHasItems">
                <div class="text-center">
                    <button id="proceedToCheckoutButton" v-on:click="redirectToCart" class="btn btn-proceed btn-enable-progress" style="width:100%;">{{getInterfaceText('shop_proceedtocheckout')}}</button>
                    <p>
                        <a href="javascript:void(0);" v-on:click="toggleCartSlider(false)" class="continue">{{getInterfaceText('shop_continueshopping')}}</a>
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import CartTable from '@/components/CartTable.vue';
    import CartTotals from '@/components/CartTotals.vue';
    import RelatedProducts from '@/components/RelatedProducts.vue';
    export default {
        name: 'CartSummary',
        mixins: [cartMixin, generalMixin],
        components: {
            CartTable,
            CartTotals,
            RelatedProducts
        },
        data: function () {
            return {
                isCartSummaryOpen: false,
                loading: true,
                culture: window.culture,
                isInTestMode: window.window.inTestMode,
                enableDiscoverMode: window.enableDiscoverMode,
                enableDiscoverModeCart: window.enableDiscoverModeCart,
                ignoreItemCount: window.enableDiscoverMode,
                displaySlider: 'display:none;',
                isOpen: {
                    type: Boolean,
                    default: false
                },
                hasCartCookie: false
            } 
        },
        beforeMount() {
            // get summary only when cart cookie exists
            if (this.hasCartCookie) {
                this.getCartSummary(false);
            }
        },
        methods: {
            cookieExists(namePrefix) {
                if (!document || !document.cookie) return false;
                const cookies = document.cookie.split('; ').map(c => c.split('=')[0]);
                return cookies.some(key =>
                    key === namePrefix ||
                    key.toLowerCase() === namePrefix.toLowerCase() ||
                    key.startsWith(namePrefix + '-') // e.g. cart-en-store-...
                );
            },
            redirectToCart: function () {
                window.location = '/' + this.culture + '/shop/review';
            },
            toggleCartSlider(showSlider, nrOfItems) {
                var hasItems = nrOfItems > 0;
                var that = this;
                
                if (showSlider && (hasItems || this.ignoreItemCount)) {
                    this.displaySlider = 'display:block';
                    setTimeout(function () {
                        // then slide
                        that.isCartSummaryOpen = true;
                    }, 100);
                    // no scrolling in the body
                    document.body.style.overflow = 'hidden';
                    document.body.classList.add('cart-open');
                    // a360
                    setTimeout(function () {
                        document.getElementById('cartCloseButton').focus();
                    }, 100);
                    // ga4
                    if (hasItems) {
                        this.handleGA4data();
                    }
                } else {
                    this.isCartSummaryOpen = false;
                    setTimeout(function () {
                        // then slide
                        that.displaySlider = 'display:none';
                    }, 100);
                    // scrolling is back 
                    document.body.style.overflow = 'unset';
                    document.body.classList.remove('cart-open');
                    //set focus on link A360
                    document.getElementById('cart-summary-container2').focus();
                }

                // visible vs hidden for a360
                setTimeout(function () {
                    const myCart = document.getElementById('cart-summary-slider');
                    var cartContainsOpenClass = myCart.classList.contains('slide-out');
                    if (cartContainsOpenClass) {
                        myCart.style.visibility = '';
                    } else {
                        myCart.style.visibility = 'hidden';
                    }
                }, 100);
            },
            handleGA4data: function () {

                //GA4
                var items = [];
                for (var i = 0; i < this.Cart.CartItems.length; i++) {
                    items.push({
                        'item_id': (this.Cart.CartItems[i].Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + this.Cart.CartItems[i].Product.Id.toString(),
                        'item_name': this.Cart.CartItems[i].Product.Name.toLowerCase(),
                        'discount': this.Cart.CartItems[i].Product.Partnumber.PriceOriginal > 0 ? this.Cart.CartItems[i].Product.Partnumber.PriceOriginal - this.Cart.CartItems[i].Product.Partnumber._price : 0,
                        'index': i,
                        'item_brand': this.Cart.CartItems[i].Product.BrandName.toLowerCase(),
                        'item_category': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 0 ? this.Cart.CartItems[i].Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                        'item_category2': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 1 ? this.Cart.CartItems[i].Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                        'item_category3': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 2 ? this.Cart.CartItems[i].Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                        /*'item_list_name': this.Cart.CartItems[i].Product.GA_Category,*/
                        'item_variant': (this.Cart.CartItems[i].Product.Partnumber.Size + (this.Cart.CartItems[i].Product.Partnumber.Color != undefined && this.Cart.CartItems[i].Product.Partnumber.Color.length > 0 ? ' ' + this.Cart.CartItems[i].Product.Partnumber.Color : '')).toLowerCase(),
                        'price': this.Cart.CartItems[i].Product.Partnumber.PriceOriginal,
                        'quantity': this.Cart.CartItems[i].Quantity
                    });
                }
                window.trackEventGlobalAndLocalGA4({
                    'ga4_name': 'view_cart',
                    'ga4_currency': window.currencyCode,
                    'ga4_value': this.Cart.TotalIncludingShippingCosts,
                    'ga4_items': items
                });

                //Related products
                let result = [];
                for (let item of this.Cart.RelatedProducts) {
                    let newItem = {
                        item_id: 'gearproduct-' + item.Id,
                        item_name: item.Name,
                        index: item.Index,
                        item_brand: item.Brand,
                        item_category: item.Category,
                        item_category2: item.Category2,
                        item_category3: item.Category3,
                        price: item.Price,
                        discount: item.Discount,
                        quantity: 1
                    }
                    result.push(newItem);
                }

                window.trackEventGlobalAndLocalGA4({
                    'ga4_name': 'view_item_list',
                    'ga4_item_list_name': 'complete your rider experience',
                    'ga4_location': 'mini cart',
                    'ga4_items': result
                });
            },
            handleKeydown(event) {
                const focusableElements = this.getFocusableElements();
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                if (event.key === 'Tab') {
                    if (event.shiftKey) {
                        // Shift + Tab
                        if (document.activeElement === firstElement) {
                            event.preventDefault();
                            lastElement.focus();
                        }
                    } else {
                        // Tab
                        if (document.activeElement === lastElement) {
                            event.preventDefault();
                            firstElement.focus();
                        }
                    }
                }
            },
            getFocusableElements() {
                return this.$refs.modal.querySelectorAll(
                    'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
                );
            }
        },
        computed: {
            // See cartMixin
        },
        watch: {
            isOpen(newVal) {
                if (newVal) {
                    // Wacht tot de DOM volledig is gerenderd voordat je probeert $refs te gebruiken
                    this.$nextTick(() => {
                        const focusableElements = this.getFocusableElements();
                        if (focusableElements.length) {
                            focusableElements[0].focus(); // Focus op het eerste element bij openen
                        }
                    });
                }
            }
        },
        created() {
            // determine presence of cart cookie (e.g. "cart-en" or "cart-en-store-...")
            const cartPrefix = 'cart-' + window.cultureFull;
            this.hasCartCookie = this.cookieExists(cartPrefix);

            // only parse interface texts when cart cookie present and element exists
            const el = document.getElementById('vue-cart-parameters');
            if (el && el.dataset && el.dataset.interfacetexts) {
                this.interfaceTexts = JSON.parse(el.dataset.interfacetexts);
            }
        }
    }
</script>